import { FC } from "react";
import { ITrainControlsResponse } from "../../interfaces";
import { Box } from "@mui/material";
import { useAlarmColor } from "../../../../../../../../hooks/use-alarm-color";

interface ITiLedRoundProps {
  control: ITrainControlsResponse;
  overrideAlarmStatus?: number | null;
}

export const TiLedRound: FC<ITiLedRoundProps> = ({ control, overrideAlarmStatus }) => {
  const { props, alarmStatus } = control;
  const ledColor = useAlarmColor(Number(overrideAlarmStatus ?? alarmStatus) || 0);

  return (
    <Box
      sx={{
        position: "absolute",
        left: props.Left,
        top: props.Top,
        width: props.Width,
        height: props.Height,
        background: ledColor,
        borderRadius: "50%",
        border: "2px solid #222",
        boxShadow: "inset 0 0 4px #888",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    />
  );
};
